import _ from 'underscore'
import SceneController from 'controllers/sceneController'
import TagListController from 'controllers/settings/tagListController'
import TagPlaceholderView from 'views/settings/tagsPlaceholderView'
import TagDetailController from 'controllers/settings/tagDetailController'
import Tags from 'collections/tags'
import ReactWrapper from 'views/marionetteReactWrapper'
import * as React from 'react'
import I18n from 'i18n'

export default class TagSceneController extends SceneController {
  show() {
    this._showPreloader();
    (new Tags()).fetch({
      success: (tags, _response, _options) => {
        this._showTagListController(tags.ofKind('manual'));
      }
    });
    this._showPlaceholder();
  }

  _showTagListController (tags) {
    this.controller = new TagListController({tags: tags});
    this.showInLeftColumn(this.controller.view);
    this._registerListeners();
  }

  _showPlaceholder() {
    var placeholder = new TagPlaceholderView();
    this.showInRightColumn(placeholder);
  }

  _showPreloader() {
    const wrapper = (jsx) => new ReactWrapper({
      getComponent: () => jsx
    });
    this.showInLeftColumn(wrapper(
      <div className="pal">
        <div className="preloader">
          <p className="preloader__label">
            { I18n.translate("webapp.agents.add_result.please_wait") }
          </p>
        </div>
      </div>
    ));
  }

  _showTag(tag) {
    this.detailController = new TagDetailController(tag);
    this.detailView = this.detailController.view;
    this.listenTo(this.detailController,
                  'tag:deleted',
                  this._closeTagDetailView
                 );
    this.showInRightColumn(this.detailView);
  }

  _registerListeners() {
    this.listenTo(
      this.controller,
      'tag:selected',
      this._showTag
    );
    this.listenTo(
      this.controller,
      'tag:deselected',
      this._closeTagDetailView
    );
  }

  _closeTagDetailView() {
    if (!_.isUndefined(this.detailView)) {
      this.detailView.close();
      this.focusRight();
      delete this.detailView;
      this._showPlaceholder();
      this.controller.deselectAll();
      this.focusRight();
    }
  }
}
